import { BLACK_HEX, WHITE_HEX } from '../../modules/theme/colors';
import contrastYIQ from './contrastYIQ';
import pSBC from './pSBC';

const shadeColor = (color, percent = 0.25) => {
  const contrast = contrastYIQ(color);

  // Lighten the color if it's light.
  if (contrast === BLACK_HEX) {
    return pSBC(percent, color);
  }

  // Darken the color if it's dark.
  if (contrast === WHITE_HEX) {
    return pSBC(-percent, color);
  }

  return color;
};

export default shadeColor;
